const styles = {
  contentContainer: 'content-box',
  textContainer: 'text-box text-body2 ml-0 mr-auto',
  heading1: 'text-h5 mb-4 last:mb-0',
  heading2: 'text-body1 font-semibold mb-4 last:mb-0',
  paragraph: 'text-body3 mb-8 last:mb-0',
};

export default styles;
